import { Injectable } from "@angular/core";
import { Observable } from 'rxjs/Observable';
import { Response } from '@angular/http';
import { Headers, RequestOptions } from '@angular/http';

import { BaseWebService } from "../shared/services/base-web.service";
import 'rxjs/add/observable/throw';
import { config } from "../../../config";

@Injectable()
export class SubscriptionService {
    constructor(
	 	private _basewebservice: BaseWebService
    ) { 
    }

    /** Service To Fetch Cities **/
    getCities = () => {
        return this._basewebservice.request("v1/cities/", "get")
            .map(res => res)
            .catch(this.handleError);
    }

    	/** Fetching practice subcription details **/
    getPracticeLocationDetails() {
        return this._basewebservice.request("v1/locations/?"+ "extra_field=location_setup_fee", "get")
            .map(res => res)
            .catch(this.handleError);	
    }

    	/** Fetching practice profile details **/
    getPracticeProfileDetails() {
        return this._basewebservice.request("v1/practice/subscription_settings/", "get")
            .map(res => res)
            .catch(this.handleError);	
    }

    /** Service save Practice **/
    savePractice = (data: any) => {
        let reqData: any = {};
        reqData.body = data;
        return this._basewebservice.request("v1/practice_profile/", "put", reqData)
            .map(res => res)
            .catch(this.handleError);
    }

    /** Service save Practice **/
    saveMonthlyAutoRewal = (data: any) => {
        let reqData: any = {};
        reqData.body = data;
        return this._basewebservice.request("v1/practice/auto_subscription/", "patch", reqData)
            .map(res => res)
            .catch(this.handleError);
    }

    // get cards
    getCards() {
        return this._basewebservice.request("v1/payments/payment-methods/", "get")
            .map(res => res)
            .catch(this.handleError);
    }

    // add card
    addCard(tokenData: any) {
        const data: any = {};
        data.body = tokenData;
        return this._basewebservice.request("v1/payments/payment-methods/", "post", data)
            .map(res => res)
            .catch(this.handleError);
    }

    // update card
    updateCard(tokenData: any) {
        tokenData.is_primary = true;
        const data: any = {};
        data.body = tokenData;
        return this._basewebservice.request("v1/payments/payment-methods/" + tokenData.id + "/", "patch", data)
            .map(res => res)
            .catch(this.handleError);
    }

    // delete card
    deleteCard(id: any) {
        return this._basewebservice.request("v1/payments/payment-methods/" + id + "/", "delete")
            .map(res => res)
            .catch(this.handleError);
    }

    handleError(error: Response | any) {
        return Observable.throw(error);
    }
    // get statements with a limit
    getStatements() {
        return this._basewebservice.request("v1/billing/statements/?limit=" + 5 + "&offset=" + 0, "get")
            .map(res => res)
            .catch(this.handleError);	
    }

    /**
     * Function to get statement pdf form from api.
     * @param  {any} id contains statement pdf id.
     */
    getStatementPdf(id: any) {
        return this._basewebservice.requestBlob("v1/billing/statements/" + id + "/download/", "get")
            .map(res => res)
            .catch(this.handleError);
    }

    // /** Service add location**/
    addLocations(data:any) {
        let reqData: any = {};
        reqData.body = data;
        return this._basewebservice.request("v1/practice/add_location/", "post", reqData)
            .map(res => res)
            .catch(this.handleError);	
    }

}
